import { render } from "./PendingInspection.vue?vue&type=template&id=2042c941&scoped=true"
import script from "./PendingInspection.vue?vue&type=script&lang=js"
export * from "./PendingInspection.vue?vue&type=script&lang=js"

import "./PendingInspection.vue?vue&type=style&index=0&id=2042c941&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2042c941"]])

export default __exports__